import React, { useState, useEffect, Fragment } from "react";
import { EnhancedSelectPreloaded } from "components/enhancedSelect";

import { Form } from "react-bulma-components";
import TrimmedInput from "common-frontend/util/trimmedInput";

const { Control } = Form;

function SimpleComboBox(props) {
  const {
    presetValues,
    presetLabels = {},
    nullLabel = "Not specified yet",
    customLabel = "Other ...",
    value,
    originalValue = "",
    setValue,
  } = props;

  const [customValue, setCustomValue] = useState(null);
  const [focusCustom, setFocusCustom] = useState(false);

  const presetValue = (v) => (v === null ? "null" : `preset-${v}`);
  const options = presetValues.map((v) => {
    return {
      value: presetValue(v),
      realValue: v,
      label: v === null ? nullLabel : presetLabels[v] ?? v,
    };
  });

  const customOption = {
    value: "custom",
    label: customLabel,
  };
  const optionsByValue = Object.fromEntries(
    options.map((option) => [option.value, option])
  );

  options.push(customOption);

  const selectedOption = optionsByValue[presetValue(value)] || customOption;
  const isCustom =
    selectedOption === customOption ||
    (customValue !== null && value === customValue);

  const initialCustomValue = optionsByValue[presetValue(originalValue)]
    ? ""
    : originalValue;

  useEffect(() => {
    if (isCustom && customValue === null) setCustomValue(initialCustomValue);
    else if (customValue !== null && !isCustom) setCustomValue(null);
  }, [isCustom, customValue, initialCustomValue]);

  const setSelectedOption = (option) => {
    if (option.value === "custom") {
      if (customValue === null) {
        setCustomValue(initialCustomValue);
        setValue(initialCustomValue);
      } else {
        setValue(customValue);
      }
      setFocusCustom(true);
    } else if (option.value === "null") {
      setFocusCustom(false);
      setValue(null);
    } else {
      setFocusCustom(false);
      setValue(option.realValue);
    }
  };

  const onCustomValueChange = (v) => {
    setValue(v);
    setCustomValue(v);
  };

  return (
    <Fragment>
      <Control>
        <EnhancedSelectPreloaded
          options={options}
          selection={isCustom ? customOption : selectedOption}
          setSelection={setSelectedOption}
          creatable
          useFixedChoices
        />
      </Control>
      {isCustom ? (
        <Control>
          <TrimmedInput
            value={customValue ?? ""}
            setValue={onCustomValueChange}
            startFocussed={focusCustom}
          />
        </Control>
      ) : null}
    </Fragment>
  );
}

export default SimpleComboBox;
